import { useMemo } from "react";
import { useQuery } from "@apollo/client/react";
import { GET_ALL_PARTNERS } from "@/hooks";

interface PartnerUser {
  userId: string;
  role: string;
}

interface Partner {
  id: string;
  name: string;
  key: string;
  companyUrl: string;
  appUrl: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  status: string;
  smtpHost?: string | null;
  smtpPort?: number | null;
  smtpUser?: string | null;
  smtpPassword?: string | null;
  smtpUseTls?: boolean | null;
  smtpUseSsl?: boolean | null;
  smtpFromEmail?: string | null;
  smtpFromName?: string | null;
  users?: PartnerUser[];
  value: string;
  label: string;
  usersCount: number;
}

interface GetPartnersResponse {
  getPartners: Partner[];
}

interface UsePartnersListReturn {
  partnerList: Partner[];
  loading: boolean;
}

/**
 * Custom hook to fetch and filter the partners list.
 */
export function usePartnersList(
  variables?: Record<string, any>,
): UsePartnersListReturn {
  const { data, loading } = useQuery<GetPartnersResponse>(GET_ALL_PARTNERS, {
    variables,
  });

  const partnerList = useMemo(() => {
    const sortedPartners =
      data?.getPartners?.slice().sort((a, b) => a.name.localeCompare(b.name)) ||
      [];

    return sortedPartners.map((partner) => ({
      ...partner,
      usersCount: partner?.users?.length || 0,
    }));
  }, [data?.getPartners]);

  return {
    // partnerList: data?.getPartners.filter(item => item.key === "energiteam") || [],
    partnerList,
    loading,
  };
}
